
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("bLtXM", function(module, exports) {

$parcel$export(module.exports, "ContentHeaderPresenceComponent", () => $1e82291b1be231ce$export$a8d99186a74b60f6);
$parcel$export(module.exports, "ContentHeaderPresence", () => $1e82291b1be231ce$export$52baa28b583c9835);
/** @graphql cc **/ 
var $gwFzn = parcelRequire("gwFzn");

var $xQxzY = parcelRequire("xQxzY");

var $d2LG0 = parcelRequire("d2LG0");

var $dIouf = parcelRequire("dIouf");

var $9wGTI = parcelRequire("9wGTI");

var $3jwuS = parcelRequire("3jwuS");

var $jXpbL = parcelRequire("jXpbL");

var $de2j9 = parcelRequire("de2j9");

var $ln0hx = parcelRequire("ln0hx");
var $1kHsc = parcelRequire("1kHsc");
var $irVI7 = parcelRequire("irVI7");

var $8Lx5S = parcelRequire("8Lx5S");
var $bQm3c = parcelRequire("bQm3c");

var $cLo2u = parcelRequire("cLo2u");

var $7Sm4c = parcelRequire("7Sm4c");

var $efvKr = parcelRequire("efvKr");

var $lkApp = parcelRequire("lkApp");

var $9VtwR = parcelRequire("9VtwR");

var $gLdsO = parcelRequire("gLdsO");

var $lx2Vu = parcelRequire("lx2Vu");
const $1e82291b1be231ce$var$createDefaultParticipant = ({ presenceId: presenceId, activity: activity, user: user, isGuest: isGuest })=>{
    const sessions = {
        [(0, $9VtwR.CURRENT_USER_DUMMY_SESSION_ID)]: {
            activity: activity
        }
    };
    const usablePresenceId = user?.id ?? presenceId;
    return {
        id: usablePresenceId,
        userId: user?.id ?? 'unidentified',
        presenceId: usablePresenceId,
        name: user?.displayName ?? '',
        src: user?.photos?.[0]?.value ?? '',
        isCurrentUser: true,
        isGuest: isGuest,
        sessions: sessions
    };
};
const $1e82291b1be231ce$export$a8d99186a74b60f6 = ({ collaborators: collaborators, contentId: contentId, contentType: contentType, isViewMode: isViewMode, analyticSource: analyticSource })=>{
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { cloudId: cloudId, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const isGuest = (0, $8Lx5S.useIsGuest)();
    const spaceKey = (0, $cLo2u.useSpaceKey)();
    const isEditPage = (0, $de2j9.useIsEditorPage)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const [{ isEditMode: isLiveEditMode }] = (0, $efvKr.useLivePageMode)();
    const { data: userData, error: userQueryError } = (0, $xQxzY.useQuery)((0, $d2LG0.default)`query ContentHeaderPresenceUserQuery{user:confluence_atlassianUser(current:true){id displayName photos{value isPrimary}}}`);
    // presenceId is pulled from the native collab state to ensure that we have a consistent presenceId for a given contentId
    // across the collab providers that drive editor as well as presence components (telepointer and avatar colors).
    const [{ presenceId: presenceId }] = (0, $jXpbL.useNativeCollabPresenceState)();
    const presenceIdRef = (0, $gwFzn.useRef)(presenceId);
    let contentMode = 'view';
    if (isLivePage) contentMode = 'live';
    else if (isEditPage) contentMode = 'edit';
    const activity = contentMode === 'edit' || contentMode === 'live' && (isLiveEditMode || !isViewMode) ? 'editor' : 'viewer';
    const { data: settingData, error: settingsQueryError } = (0, $xQxzY.useQuery)((0, $d2LG0.default)`query ContentHeaderPresenceContentSettingsQuery($cloudId:ID!$spaceKey:String!){confluence_teamPresenceContentSetting(cloudId:$cloudId spaceKey:$spaceKey){isEnabledOnContentView}}`, {
        variables: {
            cloudId: cloudId,
            spaceKey: spaceKey ?? ''
        },
        skip: !(0, $9wGTI.fg)('confluence_team_presence_enable_on_view') || contentType === 'whiteboard' || contentMode !== 'view'
    });
    const error = userQueryError || settingsQueryError;
    const isAnonymousBlockedOnView = !isLoggedIn && (0, $9wGTI.fg)('confluence_team_presence_prevent_anonymous_on_view');
    const isSettingEnabledOnView = (0, $gwFzn.useCallback)(()=>{
        if (contentType === 'whiteboard' && (0, $9wGTI.fg)('confluence_team_presence_whiteboard')) return true;
        else return settingData?.confluence_teamPresenceContentSetting?.isEnabledOnContentView === true;
    }, [
        contentType,
        settingData
    ]);
    if (!contentType) return null;
    if (error) {
        experienceTracker.fail({
            name: (0, $irVI7.TEAM_PRESENCE_AVATAR_GROUP_VIEW_EXPERIENCE),
            error: error
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
        return null;
    }
    if (contentMode === 'view') {
        if (!isSettingEnabledOnView()) {
            experienceTracker.abort({
                name: (0, $irVI7.TEAM_PRESENCE_AVATAR_GROUP_VIEW_EXPERIENCE),
                reason: `Real-time visibility is disabled on view mode`
            });
            return null;
        }
        if (isAnonymousBlockedOnView) {
            experienceTracker.abort({
                name: (0, $irVI7.TEAM_PRESENCE_AVATAR_GROUP_VIEW_EXPERIENCE),
                reason: `Real-time visibility is disabled on view mode for anonymous users`
            });
            return null;
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lkApp.PresenceStoreContainer), {
        participant: $1e82291b1be231ce$var$createDefaultParticipant({
            presenceId: presenceIdRef.current,
            activity: activity,
            user: userData?.user,
            isGuest: isGuest
        })
    }, contentType === 'whiteboard' && (0, $9wGTI.fg)('confluence_team_presence_whiteboard') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lx2Vu.CanvasPresence), {
        collaborators: collaborators,
        contentId: contentId,
        contentType: contentType,
        analyticSource: analyticSource
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gLdsO.PagePresence), {
        contentId: contentId,
        contentMode: contentMode,
        contentType: contentType,
        activity: activity,
        analyticSource: analyticSource
    }));
};
const $1e82291b1be231ce$export$52baa28b583c9835 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorBoundary), {
        attribution: (0, $dIouf.Attribution).COLLABORATION_PRESENCE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $jXpbL.NativeCollabPresenceStateContainer), {
        scope: props.contentId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ln0hx.ExperienceStart), {
        name: (0, $irVI7.TEAM_PRESENCE_AVATAR_GROUP_VIEW_EXPERIENCE)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($1e82291b1be231ce$export$a8d99186a74b60f6, props)));
};

});
parcelRegister("lkApp", function(module, exports) {

$parcel$export(module.exports, "usePresenceStoreActions", () => $2960af57d9597263$export$afdb9ee4b69111fa);
$parcel$export(module.exports, "useParticipants", () => $2960af57d9597263$export$23e4fe06e7659b53);
$parcel$export(module.exports, "useTransformedParticipants", () => $2960af57d9597263$export$5a5a291828ecb5e4);
$parcel$export(module.exports, "useActiveTelepointerBySessions", () => $2960af57d9597263$export$f1a08937c1f9340b);
$parcel$export(module.exports, "PresenceStoreContainer", () => $2960af57d9597263$export$f642eede20cf74c0);

var $iFWZA = parcelRequire("iFWZA");
var $2S0Fz = parcelRequire("2S0Fz");
var $4ZoIm = parcelRequire("4ZoIm");

var $9wGTI = parcelRequire("9wGTI");

var $9VtwR = parcelRequire("9VtwR");
// yes, all this is hella messy right now, will be refactoring and moving out of a store
const $2960af57d9597263$var$PresenceStore = (0, $4ZoIm.createStore)({
    initialState: {
        participants: new Map(),
        telepointers: new Map()
    },
    actions: {
        add: (participant)=>({ getState: getState, setState: setState })=>{
                const { participants: participants } = getState();
                // can't be null in confluence, ultimately is the userId for logged in users and presenceId for anonymous
                const { presenceId: id } = participant;
                const currentParticipants = new Map(participants);
                if (id) {
                    const previousParticipant = currentParticipants.get(id);
                    const entry = {
                        id: id,
                        userId: participant.userId,
                        presenceId: participant.presenceId,
                        name: participant.name,
                        isGuest: participant.isGuest,
                        isCurrentUser: Boolean(previousParticipant?.isCurrentUser),
                        src: participant.avatar,
                        sessions: {
                            ...previousParticipant?.sessions,
                            [participant.sessionId]: {
                                activity: participant.presenceActivity ?? 'viewer'
                            }
                        }
                    };
                    currentParticipants.set(id, entry);
                    setState({
                        participants: currentParticipants
                    });
                } else // eslint-disable-next-line no-console
                console.error("presenceId is null for participant when it shouldn't be for ", participant);
            },
        remove: (sessionId)=>({ getState: getState, setState: setState })=>{
                const { participants: participants } = getState();
                const currentParticipants = new Map(participants);
                const participant = (0, $9VtwR.getCurrentUserFromMap)(participants, sessionId);
                if (participant) {
                    if (Object.keys(participant.sessions).length === 1) {
                        currentParticipants.delete(participant.id);
                        setState({
                            participants: currentParticipants
                        });
                    } else {
                        delete participant.sessions[sessionId];
                        currentParticipants.set(participant.id, participant);
                        setState({
                            participants: currentParticipants
                        });
                    }
                } else // eslint-disable-next-line no-console
                console.error('Could not remove participant with sessionId of ', sessionId);
            },
        addTelepointerData: (data)=>({ setState: setState, getState: getState })=>{
                const state = getState();
                const participant = (0, $9VtwR.getCurrentUserFromMap)(state.participants, data.sessionId);
                if (// Don't track the telepointer data for the current user
                Boolean(participant?.isCurrentUser) || !(0, $9wGTI.fg)('confluence_team_presence_scroll_to_pointer')) return;
                const telepointers = new Map(state.telepointers);
                telepointers.set(data.sessionId, {
                    ...data,
                    timestamp: Date.now()
                });
                setState({
                    telepointers: telepointers
                });
            }
    },
    name: 'PresenceStore'
});
const $2960af57d9597263$export$7033f12ef2e1cbf5 = (0, $iFWZA.createHook)($2960af57d9597263$var$PresenceStore);
const $2960af57d9597263$export$afdb9ee4b69111fa = (0, $iFWZA.createActionsHook)($2960af57d9597263$var$PresenceStore);
const $2960af57d9597263$export$23e4fe06e7659b53 = (0, $iFWZA.createStateHook)($2960af57d9597263$var$PresenceStore, {
    selector: (state)=>state.participants
});
const $2960af57d9597263$export$d8ba5bfd88808651 = (state, props)=>{
    const { participants: participants } = state;
    const participantValues = [
        ...participants.values()
    ];
    const currentUser = (0, $9VtwR.getCurrentUserFromMap)(participants, props.sessionId);
    return participantValues.map((participant)=>{
        return {
            ...participant,
            isCurrentUser: participant.isCurrentUser,
            name: participant.userId === 'unidentified' ? props.anonymousName : participant.name,
            activity: participant.isCurrentUser && currentUser ? (0, $9VtwR.getActivityToDisplay)(participant.sessions, props.sessionId, props.activity) : (0, $9VtwR.getActivityToDisplay)(participant.sessions)
        };
    });
};
const $2960af57d9597263$export$5a5a291828ecb5e4 = (0, $iFWZA.createStateHook)($2960af57d9597263$var$PresenceStore, {
    selector: $2960af57d9597263$export$d8ba5bfd88808651
});
const $2960af57d9597263$export$172cef4c4690b3ab = (state, sessions)=>Object.keys(sessions).map((sId)=>state.telepointers.get(sId)).filter((tData)=>!!tData).sort((a, b)=>b?.timestamp - a?.timestamp)?.[0];
const $2960af57d9597263$export$f1a08937c1f9340b = (0, $iFWZA.createHook)($2960af57d9597263$var$PresenceStore, {
    selector: $2960af57d9597263$export$172cef4c4690b3ab
});
const $2960af57d9597263$export$f642eede20cf74c0 = (0, $2S0Fz.createContainer)($2960af57d9597263$var$PresenceStore, {
    onInit: ()=>({ setState: setState }, { participant: participant })=>{
            const defaultParticipants = new Map();
            if (participant) defaultParticipants.set(participant.id, {
                ...participant
            });
            setState({
                participants: defaultParticipants
            });
        }
});

});
parcelRegister("9VtwR", function(module, exports) {

$parcel$export(module.exports, "getParticipantColors", () => $6bda54ffb0f4283a$export$2fbd87a2176aa7cf);
$parcel$export(module.exports, "getCurrentUserColors", () => $6bda54ffb0f4283a$export$fecb54e21647ae4f);
$parcel$export(module.exports, "getCurrentUserFromMap", () => $6bda54ffb0f4283a$export$a8078789f7ade13a);
$parcel$export(module.exports, "getActivityToDisplay", () => $6bda54ffb0f4283a$export$8c4801f1df434a3);
$parcel$export(module.exports, "getPresenceServiceUrl", () => $6bda54ffb0f4283a$export$cd367e77e21c7f3d);
$parcel$export(module.exports, "getPresenceClientId", () => $6bda54ffb0f4283a$export$73e42e5abf6898ab);
$parcel$export(module.exports, "MAX_GROUP_SIZE", () => $6bda54ffb0f4283a$export$dd4b75f1a6268a6b);
$parcel$export(module.exports, "CURRENT_USER_DUMMY_SESSION_ID", () => $6bda54ffb0f4283a$export$a9b806721f7a3927);

var $9HkI0 = parcelRequire("9HkI0");

var $jyw2s = parcelRequire("jyw2s");
var $aFUXX = parcelRequire("aFUXX");
const $6bda54ffb0f4283a$export$2fbd87a2176aa7cf = (id)=>{
    if (!id) return (0, $aFUXX.participantColors)[0];
    return (0, $jyw2s.getParticipantColor)(id).color;
};
const $6bda54ffb0f4283a$export$fecb54e21647ae4f = ()=>{
    return {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-blue-bolder, #0C66E4)"
    };
};
const $6bda54ffb0f4283a$export$a8078789f7ade13a = (participants, sessionId)=>{
    if (sessionId) return [
        ...participants.values()
    ].find((p)=>p.sessions[sessionId]);
};
const $6bda54ffb0f4283a$export$8c4801f1df434a3 = (sessionData, currentUserSessionId, defaultActivity)=>{
    if (currentUserSessionId) return sessionData[currentUserSessionId]?.activity ?? defaultActivity ?? 'viewer';
    else {
        const hasEditor = Object.keys(sessionData).find((sessionId)=>sessionData[sessionId]?.activity === 'editor');
        return hasEditor ? 'editor' : 'viewer';
    }
};
const $6bda54ffb0f4283a$export$cd367e77e21c7f3d = ()=>{
    const route = 'collab-presence-confluence';
    if (window.location.hostname === 'localhost') {
        const host = window.__backendOriginHost;
        return `https://${host}/${route}`;
    }
    return `${window.location.origin}/${route}`;
};
const $6bda54ffb0f4283a$export$73e42e5abf6898ab = ()=>`presence-${(0, $9HkI0.v4)()}`;
const $6bda54ffb0f4283a$export$dd4b75f1a6268a6b = 4;
const $6bda54ffb0f4283a$export$a9b806721f7a3927 = 'dummy-session-id';

});


parcelRegister("gLdsO", function(module, exports) {

$parcel$export(module.exports, "PagePresence", () => $509bcff20a36ae58$export$7723f8df67e0bef7);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $gfIPU = parcelRequire("gfIPU");
var $irVI7 = parcelRequire("irVI7");

var $lkApp = parcelRequire("lkApp");

var $aC5ZO = parcelRequire("aC5ZO");

var $fgzua = parcelRequire("fgzua");

var $iXfxB = parcelRequire("iXfxB");
const $509bcff20a36ae58$var$i18n = (0, $2nPZH.defineMessages)({
    anonymousUser: {
        id: "team-presence.avatar-group.anonymous-user",
        defaultMessage: "Anonymous Person"
    }
});
const $509bcff20a36ae58$export$7723f8df67e0bef7 = ({ contentId: contentId, contentMode: contentMode, contentType: contentType, activity: activity, analyticSource: analyticSource })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { sessionId: sessionId, fetchMore: fetchMore, networkError: networkError, totalParticipants: totalParticipants } = (0, $iXfxB.usePagePresence)(contentId, contentType, contentMode, activity);
    const participants = (0, $lkApp.useTransformedParticipants)({
        activity: activity,
        sessionId: sessionId,
        anonymousName: formatMessage($509bcff20a36ae58$var$i18n.anonymousUser)
    });
    if (networkError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gfIPU.ExperienceFailure), {
        name: (0, $irVI7.TEAM_PRESENCE_AVATAR_GROUP_VIEW_EXPERIENCE),
        error: networkError
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $fgzua.PresenceChangeboarding), {
        contentId: contentId,
        contentMode: contentMode,
        contentType: contentType,
        totalParticipants: totalParticipants
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $aC5ZO.PresenceAvatarGroup), {
        contentId: contentId,
        contentMode: contentMode,
        contentType: contentType,
        analyticSource: analyticSource,
        onLoadMoreClick: fetchMore,
        participants: participants,
        totalParticipants: totalParticipants
    }));
};

});
parcelRegister("aC5ZO", function(module, exports) {

$parcel$export(module.exports, "PresenceAvatarGroup", () => $012cae68941ce2ca$export$fc163eae181faed4);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $2Pg7f = parcelRequire("2Pg7f");

var $6f0Oj = parcelRequire("6f0Oj");
var $2W0qg = parcelRequire("2W0qg");
var $ecnYn = parcelRequire("ecnYn");

var $lGgRw = parcelRequire("lGgRw");

var $inPa6 = parcelRequire("inPa6");

var $ep3mz = parcelRequire("ep3mz");

var $lgKMU = parcelRequire("lgKMU");

var $9wGTI = parcelRequire("9wGTI");

var $1eaCJ = parcelRequire("1eaCJ");
var $irVI7 = parcelRequire("irVI7");

var $8Lx5S = parcelRequire("8Lx5S");
var $bQm3c = parcelRequire("bQm3c");

var $hfPJk = parcelRequire("hfPJk");

var $6S5EB = parcelRequire("6S5EB");

var $9VtwR = parcelRequire("9VtwR");

var $g8Cct = parcelRequire("g8Cct");

var $5ZJn7 = parcelRequire("5ZJn7");

var $j66nf = parcelRequire("j66nf");

var $bF9T9 = parcelRequire("bF9T9");
const $012cae68941ce2ca$var$i18n = (0, $2nPZH.defineMessages)({
    overflowLabel: {
        id: "team-presence.avatar-group.overflow-label",
        defaultMessage: "Overflow menu"
    },
    blogpostLandmark: {
        id: "team-presence.avatar-group.blogpost-landmark",
        defaultMessage: "Active people on blog post"
    },
    pageLandmark: {
        id: "team-presence.avatar-group.page-landmark",
        defaultMessage: "Active people on page"
    }
});
const $012cae68941ce2ca$var$popupContainerStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'elevation.surface.overlay',
    boxShadow: 'elevation.shadow.overlay',
    borderRadius: 'border.radius',
    position: 'relative',
    width: '360px'
});
const $012cae68941ce2ca$var$editObjectHeaderStyles = (0, $ecnYn.xcss)({
    paddingTop: 'space.0',
    paddingBottom: 'space.0'
});
const $012cae68941ce2ca$var$overflowMoreStyles = (0, $ecnYn.xcss)({
    padding: 'space.075',
    backgroundColor: 'color.background.accent.gray.subtler',
    borderRadius: 'border.radius.400',
    color: 'color.text.subtle',
    font: 'font.heading.xxsmall',
    ':hover': {
        backgroundColor: 'color.background.accent.gray.subtler.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.accent.gray.subtler.pressed'
    }
});
const $012cae68941ce2ca$var$moreActiveStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.selected',
    color: 'color.text.selected',
    ':hover': {
        backgroundColor: 'color.background.selected.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.selected.pressed'
    }
});
const $012cae68941ce2ca$var$indicatorStyles = (0, $ecnYn.xcss)({
    minWidth: '28px',
    backgroundColor: 'color.background.neutral.subtle',
    padding: 'space.0',
    margin: 'space.025',
    borderRadius: 'border.radius.100',
    ':focus-visible': {
        outlineColor: 'color.border.focused',
        outlineStyle: 'solid',
        outlineWidth: 'border.width.outline',
        outlineOffset: 'space.050'
    }
});
const $012cae68941ce2ca$var$indicatorOverflowStyles = (0, $ecnYn.xcss)({
    minWidth: '35px',
    maxWidth: '35px'
});
const $012cae68941ce2ca$export$fc163eae181faed4 = ({ contentId: contentId, contentMode: contentMode, contentType: contentType, analyticSource: analyticSource, popupOpen: popupOpen, onLoadMoreClick: onLoadMoreClick, participants: participants, totalParticipants: totalParticipants })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const isGuest = (0, $8Lx5S.useIsGuest)();
    const isExternal = (0, $6S5EB.isExternalShareRequest)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [isPopupOpen, setIsPopupOpen] = (0, $gwFzn.useState)(popupOpen || false);
    const [isShareDialogOpen, setIsShareDialogOpen] = (0, $gwFzn.useState)(false);
    const { isUSDExperimentEnabled: isUSDExperimentEnabled } = (0, $hfPJk.useUnifiedShareDialogEligible)();
    const isAllowedToShare = (0, $gwFzn.useCallback)(()=>{
        // only 1 user, not anonymous and not guest user
        return participants.length === 1 && isLoggedIn && !isGuest && !isExternal;
    }, [
        participants,
        isLoggedIn,
        isGuest,
        isExternal
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (isPopupOpen && participants.length > 1 && participants.length <= (0, $9VtwR.MAX_GROUP_SIZE)) setIsPopupOpen(false);
    }, [
        isPopupOpen,
        participants
    ]);
    const handleShareClick = (0, $gwFzn.useCallback)((analyticsTriggerSource)=>{
        setIsPopupOpen(false);
        let shareDialogType;
        if ((0, $9wGTI.fg)('confluence_frontend_unified_restrict_and_share') || isUSDExperimentEnabled) {
            shareDialogType = 'v2';
            setIsShareDialogOpen(true);
        } else {
            shareDialogType = 'old';
            (0, $j66nf.switchToShareDialog)((openShare)=>{
                if (openShare) openShare();
            });
        }
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: analyticsTriggerSource,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'presenceShare',
                attributes: {
                    contentId: contentId,
                    contentMode: contentMode,
                    contentType: contentType,
                    shareDialog: shareDialogType
                }
            }
        }).fire();
    }, [
        contentId,
        contentMode,
        contentType,
        createAnalyticsEvent,
        isUSDExperimentEnabled
    ]);
    const toggleEmptyPresenceDialog = (0, $gwFzn.useCallback)(()=>{
        if (isAllowedToShare()) {
            setIsPopupOpen((isPopupOpenState)=>!isPopupOpenState);
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    source: analyticSource,
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'singlePresenceAvatarGroup',
                    product: 'confluence',
                    attributes: {
                        contentId: contentId,
                        contentMode: contentMode,
                        contentType: contentType,
                        toggle: isPopupOpen ? 'close' : 'open'
                    }
                }
            }).fire();
        }
    }, [
        contentId,
        contentMode,
        contentType,
        analyticSource,
        createAnalyticsEvent,
        isPopupOpen,
        isAllowedToShare
    ]);
    const isSingleParticipant = Boolean(participants && totalParticipants === 1);
    const onMoreClick = (0, $gwFzn.useCallback)((e, number)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: analyticSource,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'presenceAvatarGroupMoreButton',
                product: 'confluence',
                attributes: {
                    contentId: contentId,
                    contentType: contentType,
                    contentMode: contentMode,
                    number: number
                }
            }
        }).fire();
        setIsPopupOpen((isPopupOpenState)=>!isPopupOpenState);
        // platform-design-system-popup-ref causes the popup to close when the user clicks on the more button,
        // revisit what other types of changes we can put in place to not have to call stopPropagation
        e.stopPropagation();
    }, [
        contentId,
        contentType,
        contentMode,
        analyticSource,
        createAnalyticsEvent
    ]);
    const triggerId = isSingleParticipant ? 'no-collaborators-dialog' : 'presence-menu';
    const PopupContent = isSingleParticipant ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5ZJn7.NoCollaboratorsDialog), {
        contentId: contentId,
        contentMode: contentMode,
        contentType: contentType,
        spaceKey: spaceKey || '',
        onShareClick: handleShareClick,
        testId: triggerId
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $g8Cct.PresenceMenu), {
        contentId: contentId,
        contentMode: contentMode,
        contentType: contentType,
        onLoadMoreClick: onLoadMoreClick,
        totalParticipants: totalParticipants,
        participants: participants,
        testId: triggerId
    });
    const overflowParticipantCount = totalParticipants - (0, $9VtwR.MAX_GROUP_SIZE) + 1;
    const landmarkRegionLabel = contentType === 'blogpost' ? formatMessage($012cae68941ce2ca$var$i18n.blogpostLandmark) : formatMessage($012cae68941ce2ca$var$i18n.pageLandmark);
    const isEditObjectHeader = (0, $9wGTI.fg)('confluence_frontend_object_header') && (contentMode === 'edit' || contentMode === 'live');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1eaCJ.ExperienceSuccess), {
        name: (0, $irVI7.TEAM_PRESENCE_AVATAR_GROUP_VIEW_EXPERIENCE)
    }), participants.length === 1 && isShareDialogOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lgKMU.ShareAndRestrictDialogController), {
        contentId: contentId,
        contentType: contentType,
        allowRestrictions: true,
        pageModes: "view",
        refetchButtonData: ()=>{},
        onClose: ()=>{
            setIsShareDialogOpen(false);
        },
        isUnpublishedDraft: false
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lGgRw.default), {
        isOpen: isPopupOpen,
        onClose: ()=>setIsPopupOpen(false),
        placement: "bottom-end",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
                xcss: $012cae68941ce2ca$var$popupContainerStyles
            }, PopupContent),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
                ...triggerProps,
                paddingInline: "space.050",
                paddingBlock: "space.025",
                "aria-label": landmarkRegionLabel,
                role: "region",
                xcss: isEditObjectHeader && $012cae68941ce2ca$var$editObjectHeaderStyles,
                "data-vc": "presence-avatar-group"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2Pg7f.default), {
                appearance: "stack",
                size: "small",
                maxCount: (0, $9VtwR.MAX_GROUP_SIZE),
                data: participants,
                testId: "presence-avatar-group",
                label: landmarkRegionLabel,
                borderColor: "var(--ds-background-neutral, #091E420F)",
                onMoreClick: (e)=>onMoreClick(e, overflowParticipantCount),
                shouldPopupRenderToParent: false,
                isTooltipDisabled: true,
                overrides: {
                    Avatar: {
                        render: (_, props, index)=>{
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bF9T9.PresenceAvatarButton), {
                                key: `PresenceAvatarButton-${index}`,
                                index: index,
                                participant: participants[index],
                                contentMode: contentMode,
                                contentType: contentType,
                                contentId: contentId,
                                isSingleParticipant: isSingleParticipant,
                                toggleEmptyPresenceDialog: toggleEmptyPresenceDialog,
                                avatarProps: props,
                                analyticSource: analyticSource
                            });
                        }
                    },
                    MoreIndicator: {
                        render: (_, { buttonProps: buttonProps, isActive: isActive, borderColor: borderColor, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2W0qg.default), {
                                type: "submit",
                                ...buttonProps,
                                ...rest,
                                padding: "space.025",
                                onClick: rest.onClick,
                                xcss: [
                                    $012cae68941ce2ca$var$indicatorStyles,
                                    // TODO: This is a bug, anything above 1000 will break...
                                    overflowParticipantCount > 100 && $012cae68941ce2ca$var$indicatorOverflowStyles
                                ],
                                testId: rest.testId,
                                "data-vc": "presence-overflow",
                                "aria-label": formatMessage($012cae68941ce2ca$var$i18n.overflowLabel)
                            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
                                xcss: [
                                    $012cae68941ce2ca$var$overflowMoreStyles,
                                    isPopupOpen && $012cae68941ce2ca$var$moreActiveStyles
                                ]
                            }, overflowParticipantCount))
                    }
                }
            }))
    }));
};

});
parcelRegister("g8Cct", function(module, exports) {

$parcel$export(module.exports, "PresenceMenu", () => $d97f196b60da1ace$export$54d27edd10ac5407);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $56M4r = parcelRequire("56M4r");
var $2SlZp = parcelRequire("2SlZp");
var $7rvPL = parcelRequire("7rvPL");

var $inPa6 = parcelRequire("inPa6");

var $992wm = parcelRequire("992wm");
const $d97f196b60da1ace$var$i18n = (0, $2nPZH.defineMessages)({
    activeNowTitle: {
        id: "team-presence.menu.active.title",
        defaultMessage: "{count, plural, =0 {Active now ({count})} one {Active now ({count})} other {Active now ({count})}}"
    },
    viewingNowTitle: {
        id: "team-presence.menu.viewing.title",
        defaultMessage: "{count, plural, =0 {Viewing now ({count})} one {Viewing now ({count})} other {Viewing now ({count})}}"
    },
    editingNowTitle: {
        id: "team-presence.menu.editing.title",
        defaultMessage: "{count, plural, =0 {Editing now ({count})} one {Editing now ({count})} other {Editing now ({count})}}"
    },
    commenting: {
        id: "team-presence.menu.commenting",
        defaultMessage: "Commenting"
    },
    you: {
        id: "team-presence.menu.you",
        defaultMessage: "You"
    },
    loadMore: {
        id: "team-presence.menu.load-more",
        defaultMessage: "Load More"
    }
});
const $d97f196b60da1ace$export$54d27edd10ac5407 = ({ participants: participants, contentMode: contentMode, testId: testId, contentId: contentId, contentType: contentType, onLoadMoreClick: onLoadMoreClick, totalParticipants: totalParticipants })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $gwFzn.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'presenceMenu',
                attributes: {
                    contentId: contentId,
                    contentType: contentType,
                    contentMode: contentMode
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        contentId,
        contentType,
        contentMode
    ]);
    const getHeaderTitle = (0, $gwFzn.useCallback)((count)=>{
        if (contentMode === 'edit' && (contentType === 'page' || contentType === 'blogpost')) return formatMessage($d97f196b60da1ace$var$i18n.editingNowTitle, {
            count: count
        });
        else if (contentMode === 'view' && (contentType === 'page' || contentType === 'blogpost')) return formatMessage($d97f196b60da1ace$var$i18n.viewingNowTitle, {
            count: count
        });
        else // contentType === 'live'
        return formatMessage($d97f196b60da1ace$var$i18n.activeNowTitle, {
            count: count
        });
    }, [
        contentMode,
        contentType,
        formatMessage
    ]);
    const handleOnLoadMoreClicked = (0, $gwFzn.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'presenceMenuLoadMore',
                source: 'presenceMenu',
                attributes: {
                    participantsHydrated: participants.length,
                    totalParticipants: totalParticipants
                }
            }
        }).fire();
        onLoadMoreClick();
    }, [
        createAnalyticsEvent,
        onLoadMoreClick,
        participants,
        totalParticipants
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2SlZp.default), {
        maxHeight: 480,
        minWidth: 360,
        maxWidth: 360,
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7rvPL.default), {
        isScrollable: true,
        title: getHeaderTitle(totalParticipants),
        testId: "presence-menu-group"
    }, participants.map((participant, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $992wm.PresenceMenuItem), {
            key: `menu-item-${participant.id.slice(6)}`,
            participant: participant,
            contentMode: contentMode,
            contentId: contentId,
            contentType: contentType,
            isCurrentUser: index === 0
        })), totalParticipants !== participants.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $56M4r.default), {
        onClick: handleOnLoadMoreClicked
    }, formatMessage($d97f196b60da1ace$var$i18n.loadMore))));
};

});
parcelRegister("992wm", function(module, exports) {

$parcel$export(module.exports, "PresenceMenuItem", () => $3483060680d51265$export$e2b8ad06fb5a352f);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");

var $inPa6 = parcelRequire("inPa6");

var $5nBzc = parcelRequire("5nBzc");

var $56M4r = parcelRequire("56M4r");

var $6f0Oj = parcelRequire("6f0Oj");
var $bUlM5 = parcelRequire("bUlM5");
var $ecnYn = parcelRequire("ecnYn");

var $9fywD = parcelRequire("9fywD");

var $dv6q2 = parcelRequire("dv6q2");

var $uBose = parcelRequire("uBose");
const $3483060680d51265$var$i18n = (0, $2nPZH.defineMessages)({
    editing: {
        id: "team-presence.menu.editing",
        defaultMessage: "Editing"
    },
    viewing: {
        id: "team-presence.menu.viewing",
        defaultMessage: "Viewing"
    },
    you: {
        id: "team-presence.menu.current-user.marker",
        defaultMessage: "You"
    },
    clickToFind: {
        id: "team-presence.menu-item.click-to-find",
        defaultMessage: "Click to find"
    },
    clickToFindNotAvailable: {
        id: "team-presence.menu-item.click-to-find-not-available",
        defaultMessage: "Inactive"
    },
    clickToFollow: {
        id: "team-presence.menu-item.click-to-follow",
        defaultMessage: "Click to follow"
    }
});
const $3483060680d51265$var$DESCRIPTION_SEPARATOR = ' - ';
const $3483060680d51265$var$hiddenStyle = (0, $ecnYn.xcss)({
    visibility: 'hidden'
});
const $3483060680d51265$var$visibleStyle = (0, $ecnYn.xcss)({
    visibility: 'visible'
});
const $3483060680d51265$export$e2b8ad06fb5a352f = ({ participant: participant, contentMode: contentMode, contentId: contentId, contentType: contentType, isCurrentUser: isCurrentUser })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { isScrollToFeatureEnabled: isScrollToFeatureEnabled, isEligibleToScroll: isEligibleToScroll, scrollToTelepointer: scrollToTelepointer } = (0, $dv6q2.useScrollToTelepointer)({
        contentType: contentType,
        contentMode: contentMode,
        // TODO: https://product-fabric.atlassian.net/browse/MDS-1320
        participant: participant
    });
    const isAnonymous = participant.userId === 'unidentified';
    const hasOnClickEvent = isEligibleToScroll || Boolean(participant.onClick);
    const handleClick = (0, $gwFzn.useCallback)(()=>{
        let isScrollSuccessful = false;
        if (isEligibleToScroll) isScrollSuccessful = scrollToTelepointer();
        if (participant.onClick) participant.onClick();
        if (hasOnClickEvent) createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                product: 'confluence',
                source: 'presenceMenu',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'presenceMenuItem',
                attributes: {
                    contentId: contentId,
                    contentType: contentType,
                    contentMode: contentMode,
                    isScrollToFeatureEnabled: isScrollToFeatureEnabled,
                    isEligibleToScroll: isEligibleToScroll,
                    isScrollSuccessful: isScrollSuccessful
                }
            }
        }).fire();
    }, [
        participant,
        contentId,
        contentType,
        contentMode,
        isScrollToFeatureEnabled,
        isEligibleToScroll,
        hasOnClickEvent,
        scrollToTelepointer,
        createAnalyticsEvent
    ]);
    // A JS-based hover interaction is usually not preferred over pure CSS,
    // but since nested CSS selectors are discouraged (see the "no-nested-selectors" linting rule),
    // and we don’t have control over "ButtonItem", this seems to be the fastest valid solution for now.
    const [isHovered, setHover] = (0, $gwFzn.useState)(false);
    const handleFocus = ()=>{
        if (isScrollToFeatureEnabled || contentType === 'whiteboard') setHover(true);
    };
    const handleBlur = ()=>{
        if (isScrollToFeatureEnabled || contentType === 'whiteboard') setHover(false);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        onMouseEnter: handleFocus,
        onFocus: handleFocus,
        onMouseLeave: handleBlur,
        onBlur: handleBlur
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $56M4r.default), {
        onClick: handleClick,
        testId: "team-presence-menu-item",
        "data-vc": "team-presence-menu-item",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $uBose.PresenceAvatar), {
            testId: "team-presence-menu-item-avatar",
            participant: participant,
            contentMode: contentMode,
            contentId: contentId,
            contentType: contentType,
            isEligibleToScroll: isEligibleToScroll
        }),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, contentType !== 'whiteboard' && (participant.activity === 'editor' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $3483060680d51265$var$i18n.editing) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $3483060680d51265$var$i18n.viewing)), contentType === 'whiteboard' && participant.followCursor && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
            as: "span",
            xcss: isHovered ? $3483060680d51265$var$visibleStyle : $3483060680d51265$var$hiddenStyle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $3483060680d51265$var$i18n.clickToFollow)), isScrollToFeatureEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
            as: "span",
            xcss: isHovered ? $3483060680d51265$var$visibleStyle : $3483060680d51265$var$hiddenStyle
        }, $3483060680d51265$var$DESCRIPTION_SEPARATOR, isEligibleToScroll ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $3483060680d51265$var$i18n.clickToFind) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $3483060680d51265$var$i18n.clickToFindNotAvailable)))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bUlM5.default), {
        alignItems: "baseline",
        gap: "space.050"
    }, participant.name, participant.isGuest && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9fywD.ExternalUserLozenge), null), isCurrentUser && isAnonymous && contentType !== 'whiteboard' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5nBzc.default), {
        appearance: "inprogress"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $3483060680d51265$var$i18n.you)))));
};

});
parcelRegister("dv6q2", function(module, exports) {

$parcel$export(module.exports, "useScrollToTelepointer", () => $99b335d011a83318$export$3e8e4ca69eec4635);

var $gwFzn = parcelRequire("gwFzn");

var $h3X17 = parcelRequire("h3X17");

var $kDhla = parcelRequire("kDhla");

var $e4o8D = parcelRequire("e4o8D");

var $9wGTI = parcelRequire("9wGTI");

var $1kHsc = parcelRequire("1kHsc");
var $irVI7 = parcelRequire("irVI7");

var $lkApp = parcelRequire("lkApp");
const $99b335d011a83318$var$getTelepointerEl = (sessionId)=>{
    return document.querySelector(`[${(0, $h3X17.TELEPOINTER_DATA_SESSION_ID_ATTR)}="${sessionId}"]`);
};
const $99b335d011a83318$export$3e8e4ca69eec4635 = ({ contentType: contentType, contentMode: contentMode, participant: participant })=>{
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const isServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)(true);
    const [{ fullPageEditorPresetAPI: fullPageEditorPresetAPI }] = (0, $kDhla.useFullPageEditorApi)();
    // TODO: https://product-fabric.atlassian.net/browse/MDS-1320
    const participantSessions = participant?.sessions ?? {};
    const [activeTelepointer] = (0, $lkApp.useActiveTelepointerBySessions)(participantSessions);
    const activeTelepointerPos = activeTelepointer?.selection.head;
    const activeSessionId = activeTelepointer?.sessionId;
    const sessionData = participantSessions[activeSessionId];
    const telepointerEl = isServerPlaceholder ? null : $99b335d011a83318$var$getTelepointerEl(activeSessionId);
    // Keep the optional chaning until we have a stricter "PresenceSessionData"
    const activity = sessionData?.activity;
    const isScrollToFeatureEnabled = // This feature is only available for live docs (for "editing" users), and pages and blogposts in edit mode
    ((contentType === 'page' || contentType === 'blogpost') && contentMode === 'edit' || contentMode === 'live' && activity !== 'viewer') && // Current user won't have the onClick handler for scroll
    !participant?.isCurrentUser && // Only available if the FG allows us
    (0, $9wGTI.fg)('confluence_team_presence_scroll_to_pointer');
    const isEligibleToScroll = isScrollToFeatureEnabled && // This is to filter out cases like where we have a user but no telepointer data; e.g. no focus on the doc
    activeTelepointerPos !== undefined && activeSessionId !== undefined && // Even if we have telepointer data, that doesn't guarantee the telepointer will be in the DOM.
    // e.g. platform_editor_no_telecursor_on_live_doc_init,
    telepointerEl !== null;
    const observerRef = (0, $gwFzn.useRef)(null);
    const timeoutRef = (0, $gwFzn.useRef)(null);
    const killObserver = ()=>{
        if (observerRef.current) {
            observerRef.current.disconnect();
            observerRef.current = null;
        }
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
    };
    (0, $gwFzn.useEffect)(()=>{
        return ()=>{
            // Abort ongoing experience in case it's stuck in an unexpected state
            const expState = experienceTracker.getExperienceState((0, $irVI7.TEAM_PRESENCE_CLICK_TO_FIND_EXPERIENCE));
            if (expState?.attributes?.sessionId === activeSessionId && !expState?.hasStopped) experienceTracker.abort({
                name: (0, $irVI7.TEAM_PRESENCE_CLICK_TO_FIND_EXPERIENCE),
                reason: 'useScrollToTelepointer unmounted'
            });
        };
    }, [
        activeSessionId,
        experienceTracker
    ]);
    (0, $gwFzn.useEffect)(()=>{
        return ()=>{
            killObserver();
        };
    }, []);
    const scrollToTelepointer = (0, $gwFzn.useCallback)(()=>{
        experienceTracker.start({
            name: (0, $irVI7.TEAM_PRESENCE_CLICK_TO_FIND_EXPERIENCE),
            attributes: {
                contentType: contentType,
                contentMode: contentMode,
                sessionId: activeSessionId,
                activity: activity
            }
        });
        try {
            killObserver();
            const scrollToPos = fullPageEditorPresetAPI?.core.actions.scrollToPos;
            const nudgeTelepointer = fullPageEditorPresetAPI?.collabEdit?.commands.nudgeTelepointer;
            if (!isEligibleToScroll || !scrollToPos) {
                experienceTracker.fail({
                    name: (0, $irVI7.TEAM_PRESENCE_CLICK_TO_FIND_EXPERIENCE),
                    error: new Error('Eligibility checks failed'),
                    attributes: {
                        isEligibleToScroll: isEligibleToScroll,
                        isScrollToPosDefined: scrollToPos !== undefined
                    }
                });
                return false;
            }
            const isScrollSuccessful = scrollToPos(Number(activeTelepointerPos), {
                behavior: 'smooth',
                block: 'center'
            });
            if (isScrollSuccessful && nudgeTelepointer && telepointerEl !== null) {
                // We don't run this callback in SSR, so no need to escape it with an isSSR check
                // eslint-disable-next-line no-restricted-syntax
                observerRef.current = new IntersectionObserver(([entry])=>{
                    if (entry.isIntersecting) {
                        fullPageEditorPresetAPI?.core.actions.execute(nudgeTelepointer(activeSessionId));
                        killObserver();
                    }
                });
                observerRef.current.observe(telepointerEl);
                // Edge case: Set a timeout to disconnect the observer if intersection doesn't happen
                // 5000ms is an arbitrary time and can be reduced.
                timeoutRef.current = setTimeout(()=>{
                    killObserver();
                }, 5000);
            }
            if (!isScrollSuccessful) experienceTracker.fail({
                name: (0, $irVI7.TEAM_PRESENCE_CLICK_TO_FIND_EXPERIENCE),
                error: new Error('Scroll is not successful'),
                attributes: {
                    isNudgeTelepointerDefined: nudgeTelepointer !== undefined,
                    hasValidTelepointerElement: telepointerEl !== null
                }
            });
            else experienceTracker.succeed({
                name: (0, $irVI7.TEAM_PRESENCE_CLICK_TO_FIND_EXPERIENCE)
            });
            return isScrollSuccessful;
        } catch (error) {
            experienceTracker.fail({
                name: (0, $irVI7.TEAM_PRESENCE_CLICK_TO_FIND_EXPERIENCE),
                error: error
            });
            return false;
        }
    }, [
        activeSessionId,
        activeTelepointerPos,
        activity,
        contentMode,
        contentType,
        fullPageEditorPresetAPI,
        experienceTracker,
        isEligibleToScroll,
        telepointerEl
    ]);
    return {
        isScrollToFeatureEnabled: isScrollToFeatureEnabled,
        isEligibleToScroll: isEligibleToScroll,
        scrollToTelepointer: scrollToTelepointer
    };
};

});

parcelRegister("uBose", function(module, exports) {

$parcel$export(module.exports, "PresenceAvatar", () => $09acd215ab95c7d5$export$9b9667d767e90372);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");
var $dBxQj = parcelRequire("dBxQj");

var $esRft = parcelRequire("esRft");

var $3gadb = parcelRequire("3gadb");

var $6f0Oj = parcelRequire("6f0Oj");
var $bUlM5 = parcelRequire("bUlM5");
var $ecnYn = parcelRequire("ecnYn");

var $9VtwR = parcelRequire("9VtwR");

var $8UfDJ = parcelRequire("8UfDJ");
const $09acd215ab95c7d5$var$i18n = (0, $2nPZH.defineMessages)({
    editing: {
        id: "team-presence.menu.editing",
        defaultMessage: "Editing"
    },
    viewing: {
        id: "team-presence.menu.viewing",
        defaultMessage: "Viewing"
    },
    clickToFind: {
        id: "team-presence.menu.click-to-find",
        defaultMessage: "Click to find"
    },
    clickToFindNotAvailable: {
        id: "team-presence.menu.click-to-find-not-available",
        defaultMessage: "Inactive"
    },
    clickToFollow: {
        id: "team-presence.menu.click-to-follow",
        defaultMessage: "Click to follow"
    }
});
const $09acd215ab95c7d5$var$containerStyles = (0, $ecnYn.xcss)({
    position: 'relative'
});
const $09acd215ab95c7d5$var$avatarBadgeStyles = (0, $ecnYn.xcss)({
    position: 'absolute',
    bottom: '-2px',
    right: '-2px',
    height: '12px',
    width: '12px',
    borderRadius: '3px',
    color: 'color.text.inverse',
    // TODO: This will need to be swapped for the foregroundColor, based on sessionId
    boxShadow: 'elevation.shadow.overflow',
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: '10px',
    zIndex: 'card'
});
const $09acd215ab95c7d5$var$EditorAvatarBadge = ({ borderColor: backgroundColor, badgeTextColor: badgeTextColor, contentMode: contentMode, name: name })=>{
    const shouldRenderEditIcon = contentMode === 'view';
    const firstInitial = name?.substring(0, 1);
    /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/design-system/consistent-css-prop-usage,@atlaskit/ui-styling-standard/no-unsafe-values */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bUlM5.default), {
        testId: "editor-avatar-badge",
        alignItems: "center",
        justifyContent: "center",
        xcss: [
            $09acd215ab95c7d5$var$avatarBadgeStyles,
            (0, $ecnYn.xcss)({
                backgroundColor: backgroundColor,
                color: badgeTextColor
            })
        ]
    }, shouldRenderEditIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $8UfDJ.EditIcon), {
        testId: "editor-avatar-badge-icon",
        "aria-label": "editor"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        testId: "editor-avatar-badge-initial",
        as: "span"
    }, firstInitial));
/* eslint-enable @atlaskit/ui-styling-standard/no-imported-style-values,@atlaskit/design-system/consistent-css-prop-usage,@atlaskit/ui-styling-standard/no-unsafe-values */ };
const $09acd215ab95c7d5$export$9b9667d767e90372 = ({ contentMode: contentMode, contentId: contentId, contentType: contentType, isEligibleToScroll: isEligibleToScroll, isScrollToFeatureEnabled: isScrollToFeatureEnabled, participant: participant, ...avatarProps })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { activity: activity, color: participantColor, isCurrentUser: isCurrentUser, name: name, src: src } = participant;
    const activityText = activity === 'editor' ? formatMessage($09acd215ab95c7d5$var$i18n.editing) : formatMessage($09acd215ab95c7d5$var$i18n.viewing);
    const label = contentType === 'whiteboard' ? name : `${name} (${activityText})`;
    const showShowClickToFollow = !isCurrentUser && contentType === 'whiteboard' && participant.followCursor;
    const colors = isCurrentUser ? (0, $9VtwR.getCurrentUserColors)() : (0, $9VtwR.getParticipantColors)(participant.id);
    const borderColor = participantColor ?? colors.backgroundColor;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3gadb.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, label, showShowClickToFollow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bUlM5.default), {
            justifyContent: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $09acd215ab95c7d5$var$i18n.clickToFollow)), Boolean(isScrollToFeatureEnabled) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bUlM5.default), {
            justifyContent: "center"
        }, Boolean(isEligibleToScroll) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $09acd215ab95c7d5$var$i18n.clickToFind) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $09acd215ab95c7d5$var$i18n.clickToFindNotAvailable)))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bUlM5.default), {
        direction: "column",
        alignItems: "center",
        gap: "space.0",
        xcss: $09acd215ab95c7d5$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $esRft.default), {
        ...avatarProps,
        appearance: "circle",
        borderColor: borderColor,
        label: label,
        name: name,
        size: "small",
        src: src
    }), activity === 'editor' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($09acd215ab95c7d5$var$EditorAvatarBadge, {
        borderColor: borderColor,
        badgeTextColor: colors.textColor,
        contentMode: contentMode,
        name: name
    })));
};

});
parcelRegister("8UfDJ", function(module, exports) {

$parcel$export(module.exports, "EditIcon", () => $b923c56f908bf5f6$export$2ad141e9e3d81b82);

var $gwFzn = parcelRequire("gwFzn");

var $1s5hv = parcelRequire("1s5hv");
const $b923c56f908bf5f6$export$2ad141e9e3d81b82 = ({ testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1s5hv.default), {
        testId: testId,
        alignItems: "center",
        role: "img"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("svg", {
        width: "10",
        height: "10",
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M4.02 19.23a1 1 0 0 0 1.18 1.18l3.81-.78-4.21-4.21zM19.84 6.71l-2.12-2.12A2 2 0 0 0 16.31 4c-.51 0-1.02.2-1.41.59l-9.76 9.76 4.95 4.95 9.76-9.76a2 2 0 0 0 0-2.83"
    })));

});




parcelRegister("5ZJn7", function(module, exports) {

$parcel$export(module.exports, "NoCollaboratorsDialog", () => $1fc817270f48d66d$export$3566bbc3d99e9268);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $gdv5Z = parcelRequire("gdv5Z");
var $eyWa4 = parcelRequire("eyWa4");

var $9wGTI = parcelRequire("9wGTI");

var $efvKr = parcelRequire("efvKr");

var $hfPJk = parcelRequire("hfPJk");

var $hbrew = parcelRequire("hbrew");

var $6mKj3 = parcelRequire("6mKj3");

var $2RHOI = parcelRequire("2RHOI");
const $1fc817270f48d66d$var$i18n = (0, $2nPZH.defineMessages)({
    blogpostViewing: {
        id: "team-presence.menu.empty-state.blogpost.viewing",
        defaultMessage: "You\u2019re the only one viewing this blog post."
    },
    blogpostEditing: {
        id: "team-presence.menu.empty-state.blogpost.editing",
        defaultMessage: "You\u2019re the only one editing this blog post."
    },
    pageViewing: {
        id: "team-presence.menu.empty-state.page.viewing",
        defaultMessage: "You\u2019re the only one viewing this page."
    },
    pageEditing: {
        id: "team-presence.menu.empty-state.page.editing",
        defaultMessage: "You\u2019re the only one editing this page."
    },
    shareItWithOthersText: {
        id: "team-presence.menu.empty-state.share-it-with-others",
        defaultMessage: "Share it with others who might be interested."
    },
    publishToShareItWithOthersText: {
        id: "team-presence.menu.empty-state.publish-to-share-it-with-others",
        defaultMessage: "Publish it to share with others who might be interested."
    },
    copyLinkButtonText: {
        id: "team-presence.menu.empty-state.copy-button",
        defaultMessage: "Copy link"
    },
    sharePageButtonText: {
        id: "team-presence.menu.empty-state.page.share-button",
        defaultMessage: "Share page"
    },
    shareBlogPostButtonText: {
        id: "team-presence.menu.empty-state.blogpost.share-button",
        defaultMessage: "Share blog post"
    },
    sharePageButtonClickedText: {
        id: "team-presence.menu.empty-state.page.share-button.clicked",
        defaultMessage: "Page shared"
    },
    shareBlogPostButtonClickedText: {
        id: "team-presence.menu.empty-state.blogpost.share-button.clicked",
        defaultMessage: "Blogpost shared"
    },
    whiteboardModalDescription: {
        id: "team-presence.menu.empty-state.whiteboard",
        defaultMessage: "You\u2019re the only one on this whiteboard."
    },
    shareWhiteboardButtonText: {
        id: "team-presence.menu.empty-state.whiteboard.share-button",
        defaultMessage: "Share whiteboard"
    },
    shareWhiteboardButtonClickedText: {
        id: "team-presence.menu.empty-state.whiteboard.share-button.clicked",
        defaultMessage: "Whiteboard shared"
    },
    databaseModalDescription: {
        id: "team-presence.menu.empty-state.database",
        defaultMessage: "You\u2019re the only one on this database."
    },
    shareDatabaseButtonText: {
        id: "team-presence.menu.empty-state.database.share-button",
        defaultMessage: "Share database"
    },
    shareDatabaseButtonClickedText: {
        id: "team-presence.menu.empty-state.database.share-button.clicked",
        defaultMessage: "Database shared"
    }
});
const $1fc817270f48d66d$var$contentTypeToTranslationMap = (formatMessage, contentMode, isShareButtonDisabled)=>{
    return {
        blogpost: {
            modalDescriptionLineOne: formatMessage(contentMode === 'edit' ? $1fc817270f48d66d$var$i18n.blogpostEditing : $1fc817270f48d66d$var$i18n.blogpostViewing),
            modalDescriptionLineTwo: formatMessage(isShareButtonDisabled ? $1fc817270f48d66d$var$i18n.publishToShareItWithOthersText : $1fc817270f48d66d$var$i18n.shareItWithOthersText),
            shareButtonText: formatMessage($1fc817270f48d66d$var$i18n.shareBlogPostButtonText),
            shareButtonClickedText: formatMessage($1fc817270f48d66d$var$i18n.shareBlogPostButtonClickedText)
        },
        page: {
            modalDescriptionLineOne: formatMessage(contentMode === 'edit' ? $1fc817270f48d66d$var$i18n.pageEditing : $1fc817270f48d66d$var$i18n.pageViewing),
            modalDescriptionLineTwo: formatMessage(isShareButtonDisabled ? $1fc817270f48d66d$var$i18n.publishToShareItWithOthersText : $1fc817270f48d66d$var$i18n.shareItWithOthersText),
            shareButtonText: formatMessage($1fc817270f48d66d$var$i18n.sharePageButtonText),
            shareButtonClickedText: formatMessage($1fc817270f48d66d$var$i18n.sharePageButtonClickedText)
        },
        whiteboard: {
            modalDescriptionLineOne: formatMessage($1fc817270f48d66d$var$i18n.whiteboardModalDescription),
            modalDescriptionLineTwo: formatMessage($1fc817270f48d66d$var$i18n.shareItWithOthersText),
            shareButtonText: formatMessage($1fc817270f48d66d$var$i18n.shareWhiteboardButtonText),
            shareButtonClickedText: formatMessage($1fc817270f48d66d$var$i18n.shareWhiteboardButtonClickedText)
        },
        database: {
            modalDescriptionLineOne: formatMessage($1fc817270f48d66d$var$i18n.databaseModalDescription),
            modalDescriptionLineTwo: formatMessage($1fc817270f48d66d$var$i18n.shareItWithOthersText),
            shareButtonText: formatMessage($1fc817270f48d66d$var$i18n.shareDatabaseButtonText),
            shareButtonClickedText: formatMessage($1fc817270f48d66d$var$i18n.shareDatabaseButtonClickedText)
        }
    };
};
const $1fc817270f48d66d$export$3566bbc3d99e9268 = ({ contentMode: contentMode, onShareClick: onShareClick, contentId: contentId, contentType: contentType, spaceKey: spaceKey, testId: testId })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { isUSDExperimentEnabled: isUSDExperimentEnabled } = (0, $hfPJk.useUnifiedShareDialogEligible)();
    const { isNetworkDisabled: isNetworkDisabled } = (0, $hbrew.useEditorNetworkStatus)();
    const [{ isEditMode: isLiveEditMode }] = (0, $efvKr.useLivePageMode)();
    // Determine if the user is in edit mode. Live pages supports both edit and view modes, so
    // we need to do an additional check to see if we're in edit mode on a live pages.
    const isInEditMode = contentMode === 'edit' || contentMode === 'live' && isLiveEditMode;
    const pageMode = isInEditMode ? 'edit' : 'view';
    /*
  On edit classic page, there is no Share button (only "Update" button).
  Since there is no Share button on edit classic page with a share dialog, clicking the Share button on this modal doesn't do anything,
  so we are disabling the Share button on edit mode.
  The share button is also disabled if the network is disabled.
  */ const isShareButtonDisabled = !((0, $9wGTI.fg)('confluence_frontend_unified_restrict_and_share') || isUSDExperimentEnabled) && contentMode === 'edit' || isNetworkDisabled && (0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false);
    const translations = $1fc817270f48d66d$var$contentTypeToTranslationMap(formatMessage, pageMode, isShareButtonDisabled)[contentType];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $eyWa4.default), {
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gdv5Z.default), {
        paddingInline: "space.200",
        paddingBlockStart: "space.200"
    }, translations.modalDescriptionLineOne, "\xa0", translations.modalDescriptionLineTwo), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2RHOI.NoCollaboratorsDialogShareOptions), {
        contentId: contentId,
        contentMode: contentMode,
        contentType: contentType,
        pageMode: pageMode,
        spaceKey: spaceKey,
        copyLinkButtonLabel: formatMessage($1fc817270f48d66d$var$i18n.copyLinkButtonText),
        shareButtonLabel: translations.shareButtonText,
        isShareButtonDisabled: isShareButtonDisabled,
        onShareClick: onShareClick
    }));
};

});
parcelRegister("2RHOI", function(module, exports) {

$parcel$export(module.exports, "NoCollaboratorsDialogShareOptions", () => $b0043606230dc18b$export$e28fc561c2630abb);

var $gwFzn = parcelRequire("gwFzn");

var $hArLp = parcelRequire("hArLp");

var $gdv5Z = parcelRequire("gdv5Z");
var $u9agA = parcelRequire("u9agA");

var $inPa6 = parcelRequire("inPa6");

var $ccHMk = parcelRequire("ccHMk");

var $hkzol = parcelRequire("hkzol");
const $b0043606230dc18b$export$e28fc561c2630abb = ({ contentId: contentId, contentMode: contentMode, contentType: contentType, pageMode: pageMode, spaceKey: spaceKey, copyLinkButtonLabel: copyLinkButtonLabel, shareButtonLabel: shareButtonLabel, isShareButtonDisabled: isShareButtonDisabled, onShareClick: onShareClick })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const onShare = (0, $gwFzn.useCallback)((_)=>{
        if (onShareClick) onShareClick('noCollaboratorsDialog');
    }, [
        onShareClick
    ]);
    (0, $gwFzn.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'noCollaboratorsDialogShareOptions',
                attributes: {
                    contentMode: contentMode,
                    contentType: contentType
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        contentMode,
        contentType,
        pageMode
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gdv5Z.default), {
        padding: "space.200",
        paddingBlockStart: "space.400"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $u9agA.default), {
        alignInline: "end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hArLp.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hkzol.CopyLinkButton), {
        buttonAppearance: "subtle",
        buttonText: copyLinkButtonLabel,
        contentId: contentId,
        contentType: contentType,
        pageMode: pageMode,
        spaceKey: spaceKey,
        source: "noCollaboratorsDialog"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ccHMk.default), {
        testId: "open-share-dialog",
        appearance: "default",
        onClick: onShare,
        isDisabled: isShareButtonDisabled
    }, shareButtonLabel))));
};

});


parcelRegister("j66nf", function(module, exports) {

$parcel$export(module.exports, "switchToShareDialog", () => $f72b927cf6dfab7c$export$7be45e41397c6649);
/**
 * Switches to the share dialog by clicking the 'share-trigger-btn' element.
 *
 * This function attempts to find the element with the ID 'share-trigger-btn'. This is
 * the ID of the legacy share button in Confluence. This is no longer necessary when the
 * new Unified Share Dialog is released (around Jan 2025 - March 2025).
 */ function $f72b927cf6dfab7c$export$7be45e41397c6649(closeModal) {
    const node = document.getElementById('share-trigger-btn');
    if (node) closeModal(()=>{
        node.click();
    });
}

});

parcelRegister("bF9T9", function(module, exports) {

$parcel$export(module.exports, "PresenceAvatarButton", () => $f0ec2e1e638ea1ae$export$5baa88db8a182af5);

var $gwFzn = parcelRequire("gwFzn");

var $gdv5Z = parcelRequire("gdv5Z");

var $inPa6 = parcelRequire("inPa6");

var $9VtwR = parcelRequire("9VtwR");

var $dv6q2 = parcelRequire("dv6q2");

var $uBose = parcelRequire("uBose");
const $f0ec2e1e638ea1ae$export$5baa88db8a182af5 = ({ index: index, participant: participant, contentMode: contentMode, contentType: contentType, contentId: contentId, isSingleParticipant: isSingleParticipant, toggleEmptyPresenceDialog: toggleEmptyPresenceDialog, avatarProps: avatarProps, analyticSource: analyticSource })=>{
    const { id: id } = participant;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { isScrollToFeatureEnabled: isScrollToFeatureEnabled, isEligibleToScroll: isEligibleToScroll, scrollToTelepointer: scrollToTelepointer } = (0, $dv6q2.useScrollToTelepointer)({
        contentType: contentType,
        contentMode: contentMode,
        // TODO: https://product-fabric.atlassian.net/browse/MDS-1320
        participant: participant
    });
    const getAvatarButtonOnClickHandler = ()=>{
        if (isSingleParticipant) return toggleEmptyPresenceDialog;
        if (isEligibleToScroll) return ()=>{
            const isScrollSuccessful = scrollToTelepointer();
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    source: analyticSource,
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'presenceAvatarButton',
                    product: 'confluence',
                    attributes: {
                        contentId: contentId,
                        contentType: contentType,
                        contentMode: contentMode,
                        isScrollToFeatureEnabled: isScrollToFeatureEnabled,
                        isEligibleToScroll: isEligibleToScroll,
                        isScrollSuccessful: isScrollSuccessful
                    }
                }
            }).fire();
        };
        return participant?.onClick;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gdv5Z.default), {
        padding: "space.025",
        key: `box-${id}`,
        "data-vc": "presence-avatar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $uBose.PresenceAvatar), {
        ...avatarProps,
        participant: participant,
        contentId: contentId,
        contentMode: contentMode,
        contentType: contentType,
        key: `avatar-${id}`,
        stackIndex: (0, $9VtwR.MAX_GROUP_SIZE) - index,
        testId: `team-presence-avatar-${index}`,
        onClick: getAvatarButtonOnClickHandler(),
        isEligibleToScroll: isEligibleToScroll,
        isScrollToFeatureEnabled: isScrollToFeatureEnabled
    }));
};

});


parcelRegister("fgzua", function(module, exports) {

$parcel$export(module.exports, "ChangeboardingState", () => $c7d04c6396372c0a$export$e4d3916154c1f454);
$parcel$export(module.exports, "PresenceChangeboarding", () => $c7d04c6396372c0a$export$b11e63743c6002b2);

var $gwFzn = parcelRequire("gwFzn");

var $6cnUO = parcelRequire("6cnUO");
var $1lhEF = parcelRequire("1lhEF");
var $5izcQ = parcelRequire("5izcQ");
var $2Fndw = parcelRequire("2Fndw");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $lsxnT = parcelRequire("lsxnT");

var $4BonM = parcelRequire("4BonM");

var $lCLRo = parcelRequire("lCLRo");
var $c7d04c6396372c0a$export$e4d3916154c1f454 = /*#__PURE__*/ function(ChangeboardingState) {
    ChangeboardingState[ChangeboardingState["INITIAL"] = 0] = "INITIAL";
    ChangeboardingState[ChangeboardingState["STARTED"] = 1] = "STARTED";
    ChangeboardingState[ChangeboardingState["READY"] = 2] = "READY";
    ChangeboardingState[ChangeboardingState["ACTIVE"] = 3] = "ACTIVE";
    ChangeboardingState[ChangeboardingState["FAILED"] = 4] = "FAILED";
    ChangeboardingState[ChangeboardingState["COMPLETED"] = 5] = "COMPLETED";
    ChangeboardingState[ChangeboardingState["ABORTED"] = 6] = "ABORTED";
    return ChangeboardingState;
}({});
const $c7d04c6396372c0a$var$inProgressStates = [
    0,
    1,
    2,
    3
];
// The pulse component is wrapping avatar group which has buttons and click events.
// To have the pulse component take precedence, we need to temporarily disable the elements inside.
const $c7d04c6396372c0a$var$disablePointerEventsStyle = (0, $ecnYn.xcss)({
    pointerEvents: 'none'
});
const $c7d04c6396372c0a$var$cursorStyle = (0, $ecnYn.xcss)({
    cursor: 'pointer'
});
const $c7d04c6396372c0a$var$PointerEvents = ({ children: children, shouldDisable: shouldDisable })=>{
    if (shouldDisable) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $c7d04c6396372c0a$var$cursorStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $c7d04c6396372c0a$var$disablePointerEventsStyle
    }, children));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, children);
};
const $c7d04c6396372c0a$var$VC_IDENTIFIER = 'presence-changeboarding';
const $c7d04c6396372c0a$export$b11e63743c6002b2 = ({ children: children, contentId: contentId, contentMode: contentMode, contentType: contentType, totalParticipants: totalParticipants })=>{
    const { Spotlight: Spotlight } = (0, $lsxnT.useChoreographerAssets)();
    const presenceChangeboarding = (0, $4BonM.usePresenceChangeboarding)({
        contentId: contentId,
        contentMode: contentMode,
        contentType: contentType,
        totalParticipants: totalParticipants
    });
    const telepointerChangeboarding = (0, $lCLRo.useTelepointerChangeboarding)({
        contentId: contentId,
        contentMode: contentMode,
        contentType: contentType,
        totalParticipants: totalParticipants
    });
    const data = $c7d04c6396372c0a$var$inProgressStates.includes(presenceChangeboarding.state) ? presenceChangeboarding : telepointerChangeboarding;
    if (data.state !== 2 && data.state !== 3) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        "data-vc": $c7d04c6396372c0a$var$VC_IDENTIFIER
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6cnUO.default), {
        blanketIsTinted: false,
        onBlanketClicked: data.content.onBlanketClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5izcQ.default), {
        name: "presence-avatar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1lhEF.Pulse), {
        testId: "presence-pulse",
        "data-vc": $c7d04c6396372c0a$var$VC_IDENTIFIER,
        pulse: data.state === 2,
        radius: 3,
        onClick: data.content.onPulseClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($c7d04c6396372c0a$var$PointerEvents, {
        shouldDisable: data.state === 2
    }, children))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $2Fndw.default), null, data.state === 3 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(Spotlight, {
        target: "presence-avatar",
        key: "presence-avatar-spotlight",
        testId: "presence-avatar-spotlight",
        image: data.content?.image,
        actions: data.content?.actions,
        heading: data.content?.heading,
        label: data.content?.label,
        dialogPlacement: "bottom right",
        targetRadius: 3,
        shouldWatchTarget: true
    }, data.content?.description)));
};

});
parcelRegister("4BonM", function(module, exports) {

$parcel$export(module.exports, "usePresenceChangeboarding", () => $678798507808b300$export$bee08aad00a3684f);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $inPa6 = parcelRequire("inPa6");

var $ivb8S = parcelRequire("ivb8S");

var $9lC86 = parcelRequire("9lC86");

var $1ytiN = parcelRequire("1ytiN");

var $1BYn9 = parcelRequire("1BYn9");

var $8Lx5S = parcelRequire("8Lx5S");

var $irVI7 = parcelRequire("irVI7");

var $fgzua = parcelRequire("fgzua");

var $1XxMr = parcelRequire("1XxMr");

var $ewAQU = parcelRequire("ewAQU");
const $678798507808b300$var$i18n = (0, $2nPZH.defineMessages)({
    spotlightTitle: {
        id: "team-presence.avatar-group.spotlight.title",
        defaultMessage: "{contentType, select, page {See who\u2019s on your page} blogpost {See who\u2019s on your blog post} other {See who\u2019s on your content}}"
    },
    spotlightDescriptionForUsers: {
        id: "team-presence.avatar-group.spotlight.description-user",
        defaultMessage: "{contentType, select, page {You can now see who\u2019s viewing this page in real time.} blogpost {You can now see who\u2019s viewing this blog post in real time.} other {You can now see who\u2019s viewing this content in real time.}}"
    },
    spotlightDescriptionForAdmin: {
        id: "team-presence.avatar-group.spotlight.description-admin",
        defaultMessage: "{contentType, select, page {Your team can now see who\u2019s viewing this page in real time.} blogpost {Your team can now see who\u2019s viewing this blog post in real time.} other {Your team can now see who\u2019s viewing this content in real time.}}"
    },
    spotlightAccessibleLabel: {
        id: "team-presence.avatar-group.spotlight.label",
        defaultMessage: "Onboarding for real-time presence avatar group"
    },
    spotlightPrimaryAction: {
        id: "team-presence.avatar-group.spotlight.primary-action",
        defaultMessage: "OK"
    },
    spotlightSecondaryActionForUsers: {
        id: "team-presence.avatar-group.spotlight.secondary-action-user",
        defaultMessage: "More about visibility"
    },
    spotlightSecondaryActionForAdmin: {
        id: "team-presence.avatar-group.spotlight.secondary-action-admin",
        defaultMessage: "More about settings"
    }
});
const $678798507808b300$var$FEATURE_NAME = 'presence';
const $678798507808b300$export$f40bdf285d79e4e = 'presenceAvatarGroup';
const $678798507808b300$export$c6b232dd07adf3e8 = 'https://support.atlassian.com/confluence-cloud/docs/view-a-page/';
const $678798507808b300$export$bee08aad00a3684f = ({ contentId: contentId, contentMode: contentMode, contentType: contentType, totalParticipants: totalParticipants })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { setOnboardingState: setOnboardingState, error: setError } = (0, $ivb8S.useSetOnboardingState)();
    const { isProductAdmin: isProductAdmin } = (0, $1BYn9.useIsProductAdmin)();
    const { isLicensed: isLicensed, isGuest: isGuest } = (0, $8Lx5S.useAccessStatus)();
    const hasMoreThanOneParticipant = Boolean(totalParticipants && totalParticipants > 1);
    const isEligible = contentType !== 'whiteboard' && contentMode === 'view' && (isLicensed || isGuest) && (isProductAdmin || hasMoreThanOneParticipant);
    const { data: getData, error: getError, loading: getLoading } = (0, $ivb8S.useGetOnboardingState)((0, $9lC86.ONBOARDING_PRESENCE_PAGE_STATE_KEYS).PRESENCE_AVATAR_GROUP_PAGE_SPOTLIGHT_SEEN, !isEligible);
    const { pagePresenceAvatarGroupSpotlightSeen: isSeen } = (0, $ivb8S.deserializeState)(getData);
    const { isNewUser: isNewUser, loading: SPAViewContextLoading, error: SPAViewContextError } = (0, $gwFzn.useContext)((0, $1ytiN.SPAViewContext));
    const serverError = setError || getError || SPAViewContextError;
    const [state, setState] = (0, $gwFzn.useState)(isEligible ? (0, $fgzua.ChangeboardingState).STARTED : (0, $fgzua.ChangeboardingState).INITIAL);
    (0, $gwFzn.useEffect)(()=>{
        if (getLoading || SPAViewContextLoading) return;
        if (serverError) {
            setState((0, $fgzua.ChangeboardingState).FAILED);
            return;
        }
        if (isEligible && !isSeen && !isNewUser) {
            setState((0, $fgzua.ChangeboardingState).READY);
            return;
        }
        setState((0, $fgzua.ChangeboardingState).ABORTED);
    }, [
        SPAViewContextLoading,
        getLoading,
        isEligible,
        isNewUser,
        isSeen,
        serverError
    ]);
    (0, $ewAQU.useChangeboardingSharedEvents)({
        contentId: contentId,
        contentMode: contentMode,
        contentType: contentType,
        analyticsSource: $678798507808b300$export$f40bdf285d79e4e,
        featureName: $678798507808b300$var$FEATURE_NAME,
        experienceName: (0, $irVI7.TEAM_PRESENCE_CHANGEBOARDING_PRESENCE_EXPERIENCE),
        state: state,
        error: serverError
    });
    const handleComplete = ()=>{
        setState((0, $fgzua.ChangeboardingState).COMPLETED);
        setOnboardingState({
            key: (0, $9lC86.ONBOARDING_PRESENCE_PAGE_STATE_KEYS).PRESENCE_AVATAR_GROUP_PAGE_SPOTLIGHT_SEEN,
            value: 'true'
        });
    };
    const handleClose = ()=>{
        handleComplete();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: `${$678798507808b300$export$f40bdf285d79e4e}Spotlight`,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'presenceSpotlightClose',
                attributes: {
                    isProductAdmin: isProductAdmin
                }
            }
        }).fire();
    };
    const handleLearnMore = ()=>{
        handleComplete();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: `${$678798507808b300$export$f40bdf285d79e4e}Spotlight`,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'presenceSpotlightLearnMore',
                attributes: {
                    isProductAdmin: isProductAdmin
                }
            }
        }).fire();
    };
    const handlePulseClick = ()=>{
        setState((0, $fgzua.ChangeboardingState).ACTIVE);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: `${$678798507808b300$export$f40bdf285d79e4e}Pulse`,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'presencePulse',
                attributes: {
                    isProductAdmin: isProductAdmin
                }
            }
        }).fire();
    };
    const heading = formatMessage($678798507808b300$var$i18n.spotlightTitle, {
        contentType: contentType
    });
    const label = formatMessage($678798507808b300$var$i18n.spotlightAccessibleLabel);
    const descriptionI18n = isProductAdmin ? $678798507808b300$var$i18n.spotlightDescriptionForAdmin : $678798507808b300$var$i18n.spotlightDescriptionForUsers;
    const description = formatMessage(descriptionI18n, {
        contentType: contentType
    });
    const actions = [
        {
            onClick: handleClose,
            text: formatMessage($678798507808b300$var$i18n.spotlightPrimaryAction),
            testId: 'presence-spotlight-action-ok'
        },
        {
            onClick: handleLearnMore,
            text: isProductAdmin ? formatMessage($678798507808b300$var$i18n.spotlightSecondaryActionForAdmin) : formatMessage($678798507808b300$var$i18n.spotlightSecondaryActionForUsers),
            testId: 'presence-spotlight-action-learn-more',
            href: $678798507808b300$export$c6b232dd07adf3e8,
            target: '_blank'
        }
    ];
    return {
        featureName: $678798507808b300$var$FEATURE_NAME,
        state: state,
        error: serverError,
        content: {
            image: (/*@__PURE__*/$parcel$interopDefault($1XxMr)),
            actions: actions,
            heading: heading,
            label: label,
            description: description,
            onPulseClick: handlePulseClick
        }
    };
};

});
parcelRegister("1XxMr", function(module, exports) {
module.exports = new URL("presence-spotlight-img.518d169f.png", import.meta.url).toString();

});

parcelRegister("ewAQU", function(module, exports) {

$parcel$export(module.exports, "useChangeboardingSharedEvents", () => $c2a117d1a8c93cb2$export$a979d7c39d60603f);

var $gwFzn = parcelRequire("gwFzn");

var $inPa6 = parcelRequire("inPa6");

var $1kHsc = parcelRequire("1kHsc");

var $fgzua = parcelRequire("fgzua");
const $c2a117d1a8c93cb2$export$a979d7c39d60603f = ({ contentId: contentId, contentMode: contentMode, contentType: contentType, analyticsSource: analyticsSource, experienceName: experienceName, featureName: featureName, state: state, error: error })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext));
    (0, $gwFzn.useEffect)(()=>{
        if (state === (0, $fgzua.ChangeboardingState).STARTED) experienceTracker.start({
            name: experienceName,
            attributes: {
                contentId: contentId,
                contentMode: contentMode,
                contentType: contentType,
                changeboardingFeature: featureName
            }
        });
        if (state === (0, $fgzua.ChangeboardingState).READY) createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                source: analyticsSource,
                actionSubject: 'PresenceAvatarGroup',
                action: 'pulse shown',
                attributes: {
                    contentId: contentId,
                    contentMode: contentMode,
                    contentType: contentType,
                    changeboardingFeature: featureName
                }
            }
        }).fire();
        if (state === (0, $fgzua.ChangeboardingState).ACTIVE) createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                source: analyticsSource,
                actionSubject: 'PresenceAvatarGroup',
                action: 'spotlight shown',
                attributes: {
                    contentId: contentId,
                    contentMode: contentMode,
                    contentType: contentType,
                    changeboardingFeature: featureName
                }
            }
        }).fire();
        if (state === (0, $fgzua.ChangeboardingState).COMPLETED) experienceTracker.succeed({
            name: experienceName
        });
        if (state === (0, $fgzua.ChangeboardingState).FAILED && error) {
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    source: analyticsSource,
                    actionSubject: 'PresenceAvatarGroup',
                    action: 'pulse failed',
                    attributes: {
                        contentId: contentId,
                        contentMode: contentMode,
                        contentType: contentType,
                        changeboardingFeature: featureName
                    }
                }
            }).fire();
            experienceTracker.fail({
                name: experienceName,
                error: error
            });
        }
        if (state === (0, $fgzua.ChangeboardingState).ABORTED) experienceTracker.abort({
            name: experienceName,
            reason: 'Changeboarding done'
        });
    }, [
        state,
        featureName,
        error,
        contentId,
        contentMode,
        contentType,
        createAnalyticsEvent,
        analyticsSource,
        experienceTracker,
        experienceName
    ]);
    (0, $gwFzn.useEffect)(()=>{
        return ()=>{
            experienceTracker.abort({
                name: experienceName,
                reason: 'Changeboarding unmounted'
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};

});


parcelRegister("lCLRo", function(module, exports) {

$parcel$export(module.exports, "useTelepointerChangeboarding", () => $e897cb29e1e019b6$export$d9978fdd7173c803);

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $inPa6 = parcelRequire("inPa6");

var $ivb8S = parcelRequire("ivb8S");

var $9lC86 = parcelRequire("9lC86");

var $1ytiN = parcelRequire("1ytiN");

var $1BYn9 = parcelRequire("1BYn9");

var $8Lx5S = parcelRequire("8Lx5S");

var $9wGTI = parcelRequire("9wGTI");

var $irVI7 = parcelRequire("irVI7");

var $fgzua = parcelRequire("fgzua");

var $hI61r = parcelRequire("hI61r");

var $ewAQU = parcelRequire("ewAQU");
const $e897cb29e1e019b6$var$i18n = (0, $2nPZH.defineMessages)({
    heading: {
        id: "team-presence.avatar-group.spotlight.telepointer.title",
        defaultMessage: "Find where people are editing"
    },
    description: {
        id: "team-presence.avatar-group.spotlight.telepointer.description",
        defaultMessage: "Click an editor\u2019s avatar to jump to where they\u2019re working in the page or doc."
    },
    primaryAction: {
        id: "team-presence.avatar-group.spotlight.telepointer.primary-action",
        defaultMessage: "OK"
    },
    accessibleLabel: {
        id: "team-presence.avatar-group.spotlight.telepointer.label",
        defaultMessage: "Onboarding for click to find users feature"
    }
});
const $e897cb29e1e019b6$var$FEATURE_NAME = 'telepointer';
const $e897cb29e1e019b6$export$2e91587c5ab71623 = 'telepointerAvatarGroup';
const $e897cb29e1e019b6$export$d9978fdd7173c803 = ({ contentId: contentId, contentMode: contentMode, contentType: contentType, totalParticipants: totalParticipants })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { setOnboardingState: setOnboardingState, error: setError } = (0, $ivb8S.useSetOnboardingState)();
    const { isProductAdmin: isProductAdmin } = (0, $1BYn9.useIsProductAdmin)();
    const { isNewUser: isNewUser, loading: SPAViewContextLoading, error: SPAViewContextError } = (0, $gwFzn.useContext)((0, $1ytiN.SPAViewContext));
    const { isLicensed: isLicensed, isGuest: isGuest } = (0, $8Lx5S.useAccessStatus)();
    const hasMoreThanOneParticipant = Boolean(totalParticipants && totalParticipants > 1);
    const isEligible = ((contentType === 'page' || contentType === 'blogpost') && contentMode === 'edit' || contentMode === 'live') && (isLicensed || isGuest) && (isProductAdmin || hasMoreThanOneParticipant) && (0, $9wGTI.fg)('confluence_team_presence_scroll_to_pointer');
    const { data: getData, error: getError, loading: getLoading } = (0, $ivb8S.useGetOnboardingState)((0, $9lC86.ONBOARDING_PRESENCE_PAGE_STATE_KEYS).TELEPOINTER_AVATAR_GROUP_PAGE_SPOTLIGHT_SEEN, !isEligible);
    const { pageTelepointerAvatarGroupSpotlightSeen: isSeen } = (0, $ivb8S.deserializeState)(getData);
    const serverError = setError || getError || SPAViewContextError;
    const [state, setState] = (0, $gwFzn.useState)(isEligible ? (0, $fgzua.ChangeboardingState).STARTED : (0, $fgzua.ChangeboardingState).INITIAL);
    (0, $gwFzn.useEffect)(()=>{
        if (getLoading || SPAViewContextLoading) return;
        if (serverError) {
            setState((0, $fgzua.ChangeboardingState).FAILED);
            return;
        }
        if (isEligible && !isSeen && !isNewUser) {
            setState((0, $fgzua.ChangeboardingState).READY);
            return;
        }
        setState((0, $fgzua.ChangeboardingState).ABORTED);
    }, [
        SPAViewContextLoading,
        getLoading,
        isEligible,
        isNewUser,
        isSeen,
        serverError
    ]);
    (0, $ewAQU.useChangeboardingSharedEvents)({
        contentId: contentId,
        contentMode: contentMode,
        contentType: contentType,
        analyticsSource: $e897cb29e1e019b6$export$2e91587c5ab71623,
        featureName: $e897cb29e1e019b6$var$FEATURE_NAME,
        experienceName: (0, $irVI7.TEAM_PRESENCE_CHANGEBOARDING_TELEPOINTER_EXPERIENCE),
        state: state,
        error: serverError
    });
    const handleComplete = ()=>{
        setState((0, $fgzua.ChangeboardingState).COMPLETED);
        setOnboardingState({
            key: (0, $9lC86.ONBOARDING_PRESENCE_PAGE_STATE_KEYS).TELEPOINTER_AVATAR_GROUP_PAGE_SPOTLIGHT_SEEN,
            value: 'true'
        });
    };
    const handleClose = ()=>{
        handleComplete();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: `${$e897cb29e1e019b6$export$2e91587c5ab71623}Spotlight`,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'telepointerSpotlightClose'
            }
        }).fire();
    };
    const handlePulseClick = ()=>{
        setState((0, $fgzua.ChangeboardingState).ACTIVE);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: `${$e897cb29e1e019b6$export$2e91587c5ab71623}Spotlight`,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'telepointerPulse'
            }
        }).fire();
    };
    const heading = formatMessage($e897cb29e1e019b6$var$i18n.heading);
    const label = formatMessage($e897cb29e1e019b6$var$i18n.accessibleLabel);
    const description = formatMessage($e897cb29e1e019b6$var$i18n.description);
    const actions = [
        {
            onClick: handleClose,
            text: formatMessage($e897cb29e1e019b6$var$i18n.primaryAction)
        }
    ];
    return {
        featureName: $e897cb29e1e019b6$var$FEATURE_NAME,
        state: state,
        error: serverError,
        content: {
            image: (/*@__PURE__*/$parcel$interopDefault($hI61r)),
            actions: actions,
            heading: heading,
            label: label,
            description: description,
            onPulseClick: handlePulseClick,
            onBlanketClick: handleClose
        }
    };
};

});
parcelRegister("hI61r", function(module, exports) {
module.exports = new URL("telepointer-spotlight-img.686800d4.png", import.meta.url).toString();

});



parcelRegister("iXfxB", function(module, exports) {

$parcel$export(module.exports, "usePagePresence", () => $5748c7d61e5bba21$export$457bc606c36b9a3f);

var $gwFzn = parcelRequire("gwFzn");

var $hvdlr = parcelRequire("hvdlr");

var $jXpbL = parcelRequire("jXpbL");

var $8Lx5S = parcelRequire("8Lx5S");
var $bQm3c = parcelRequire("bQm3c");

var $7Sm4c = parcelRequire("7Sm4c");

var $lkApp = parcelRequire("lkApp");

var $9VtwR = parcelRequire("9VtwR");

var $5gaYz = parcelRequire("5gaYz");

var $k9TfW = parcelRequire("k9TfW");

var $9UaSY = parcelRequire("9UaSY");
const $5748c7d61e5bba21$var$MAX_FETCH_SIZE = 25;
const $5748c7d61e5bba21$export$457bc606c36b9a3f = (contentId, contentType, contentMode, activity)=>{
    const shouldCreatePresenceConnection = contentMode === 'view';
    const [{ collabEditInitialized: collabEditInitialized, collabEditProvider: collabEditProvider }] = (0, $jXpbL.useNativeCollabState)();
    // presenceId is pulled from the native collab state to ensure that we have a consistent presenceId for a given contentId
    // across the collab providers that drive editor as well as presence components (telepointer and avatar colors).
    const [{ presenceId: presenceId }] = (0, $jXpbL.useNativeCollabPresenceState)();
    const { add: add, remove: remove, addTelepointerData: addTelepointerData } = (0, $lkApp.usePresenceStoreActions)();
    const participants = (0, $lkApp.useParticipants)();
    const { cloudId: cloudId, userId: userId, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const isLicensed = (0, $8Lx5S.useIsLicensed)();
    const isGuest = (0, $8Lx5S.useIsGuest)();
    const sessions = (0, $gwFzn.useRef)(new Set());
    const providerRef = (0, $gwFzn.useRef)(collabEditProvider);
    const presenceIdRef = (0, $gwFzn.useRef)(presenceId);
    // really for testing purposes
    const [isInitialized, setIsInitialized] = (0, $gwFzn.useState)(false);
    const [networkError, setNetworkError] = (0, $gwFzn.useState)(undefined);
    (0, $5gaYz.usePresenceLimiter)({
        contentId: contentId,
        contentType: contentType,
        contentMode: contentMode,
        participants: participants,
        provider: providerRef.current
    });
    const getUsers = (0, $gwFzn.useCallback)((userIds)=>{
        return isGuest || !isLoggedIn || !isLicensed ? (0, $k9TfW.fetchPresenceAGGUsers)(userIds) : (0, $9UaSY.fetchPresenceConfluenceUsers)(userIds);
    }, [
        isGuest,
        isLoggedIn,
        isLicensed
    ]);
    const fetchMore = ()=>{
        providerRef.current?.fetchMore({
            fetchSize: $5748c7d61e5bba21$var$MAX_FETCH_SIZE
        });
    };
    const getTotalParticipants = ()=>{
        const uniqueSet = new Set();
        // really just needed for current user id before socket connects, but keeping it simple and just iterate though all participants
        participants.forEach((p)=>uniqueSet.add(p.presenceId));
        // participants from connection
        providerRef.current?.getParticipants().forEach((p)=>uniqueSet.add(p.presenceId));
        return uniqueSet.size;
    };
    const handleOnFetchError = (error)=>{
        // want to prevent an infinite spam of api calls being made
        setNetworkError(error);
        (0, $7Sm4c.markErrorAsHandled)(error);
    };
    const handleOnPresence = (0, $gwFzn.useCallback)(()=>{
        const people = providerRef.current?.getParticipants().filter((p)=>p.isHydrated);
        people?.forEach((participant)=>{
            sessions.current.add(participant.sessionId);
            add(participant);
        });
        const participantSessions = people?.map((p)=>p.sessionId) ?? [];
        // getParticipants returns all active users, so need to determine which ones to remove
        sessions.current.forEach((sessionId)=>{
            if (!participantSessions.includes(sessionId)) {
                remove(sessionId);
                sessions.current.delete(sessionId);
            }
        });
    }, // don't let this depend on anything with frequent state changes to avoid unnecessary subscriptions and un-subscriptions of the event handling
    [
        add,
        remove
    ]);
    const initializeProvider = (0, $gwFzn.useCallback)(()=>{
        const permissionTokenRefresh = (0, $jXpbL.fetchCollabPermissionToken)(contentId, undefined);
        const documentAri = `ari:cloud:confluence:${cloudId}:${contentType}/${contentId}`;
        // In order to support deduplication of the collaborator, presenceId will be set to the userId if it exists.
        // This means that anonymous users will still rely on presenceId and not get deduplicated.
        const collaboratorPresenceId = userId ?? presenceIdRef.current;
        const provider = (0, $hvdlr.createSocketIOCollabProvider)({
            url: (0, $9VtwR.getPresenceServiceUrl)(),
            documentAri: documentAri,
            permissionTokenRefresh: permissionTokenRefresh,
            need404: true,
            isPresenceOnly: true,
            productInfo: {
                product: 'confluence',
                subProduct: 'team-presence'
            },
            batchProps: {
                batchSize: $5748c7d61e5bba21$var$MAX_FETCH_SIZE,
                participantsLimit: (0, $9VtwR.MAX_GROUP_SIZE) + 1,
                getUsers: getUsers,
                onError: handleOnFetchError
            },
            presenceId: collaboratorPresenceId,
            presenceActivity: 'viewer'
        });
        // Since we moved to only creating a presence connection on view pages, we should always be a viewer
        provider.setupForPresenceOnly((0, $9VtwR.getPresenceClientId)());
        providerRef.current = provider;
        setIsInitialized(true);
    }, [
        cloudId,
        contentId,
        contentType,
        getUsers,
        userId
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (shouldCreatePresenceConnection) initializeProvider();
        else setIsInitialized(true);
        // When we don't have a provider and we are not creating a presence connection,
        // we should use the existing collabEditProvider, there was an edge case where this provider wasn't
        // available on the first render.
        if (!providerRef.current && collabEditProvider) providerRef.current = collabEditProvider;
        providerRef.current?.on('presence', handleOnPresence);
        providerRef.current?.on('presence:changed', handleOnPresence);
        providerRef.current?.on('telepointer', addTelepointerData);
        return ()=>{
            providerRef.current?.off('presence', handleOnPresence);
            providerRef.current?.off('presence:changed', handleOnPresence);
            providerRef.current?.off('telepointer', addTelepointerData);
            // we do not want to destroy the live connection, since we didn't create it
            if (shouldCreatePresenceConnection) providerRef.current?.destroy();
        };
    }, [
        addTelepointerData,
        collabEditProvider,
        shouldCreatePresenceConnection,
        initializeProvider,
        handleOnPresence
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (shouldCreatePresenceConnection || !collabEditInitialized) return;
        providerRef.current?.sendMessage({
            type: 'participant:activity',
            activity: activity
        });
    }, [
        activity,
        collabEditInitialized,
        shouldCreatePresenceConnection
    ]);
    (0, $gwFzn.useEffect)(()=>{
        presenceIdRef.current = presenceId;
    }, [
        presenceId
    ]);
    return {
        isInitialized: isInitialized,
        presenceId: presenceId,
        // want to return DUMMY as a default to preserve activity lookup if provider isn't available yet
        sessionId: providerRef.current?.getSessionId() ?? (0, $9VtwR.CURRENT_USER_DUMMY_SESSION_ID),
        fetchMore: fetchMore,
        networkError: networkError,
        totalParticipants: getTotalParticipants()
    };
};

});
parcelRegister("5gaYz", function(module, exports) {

$parcel$export(module.exports, "usePresenceLimiter", () => $e412362ca5524ae7$export$ca2b752d32a4ba83);

var $gwFzn = parcelRequire("gwFzn");

var $inPa6 = parcelRequire("inPa6");

var $bQm3c = parcelRequire("bQm3c");

var $9wGTI = parcelRequire("9wGTI");
//TODO dynamic configs https://product-fabric.atlassian.net/browse/MDS-1207
const $e412362ca5524ae7$var$SESSION_LIMIT = 50;
const $e412362ca5524ae7$var$TOTAL_SESSION_LIMIT = 1000;
const $e412362ca5524ae7$export$ca2b752d32a4ba83 = ({ contentId: contentId, contentMode: contentMode, contentType: contentType, participants: participants, provider: provider })=>{
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const getTotalSessions = (0, $gwFzn.useCallback)(()=>{
        return provider?.getParticipants().length ?? 0;
    }, [
        provider
    ]);
    const checkSessionLimit = (0, $gwFzn.useCallback)((currentUser, totalSessions)=>{
        const currentUserHasReachedSessionLimit = currentUser && Object.keys(currentUser.sessions).length > $e412362ca5524ae7$var$SESSION_LIMIT;
        if (currentUserHasReachedSessionLimit || totalSessions > $e412362ca5524ae7$var$TOTAL_SESSION_LIMIT) {
            provider?.destroy();
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    source: 'presenceAvatarGroup',
                    action: 'destroyConnection',
                    actionSubject: 'presenceAvatarGroupConnection',
                    attributes: {
                        sessionLimitType: currentUserHasReachedSessionLimit ? 'currentUser' : 'totalSessions',
                        contentId: contentId,
                        contentType: contentType
                    }
                }
            }).fire();
        }
    }, [
        contentId,
        contentType,
        createAnalyticsEvent,
        provider
    ]);
    (0, $gwFzn.useEffect)(()=>{
        // only for presence connections
        if (!(0, $9wGTI.fg)('confluence_team_presence_limiter') || contentMode !== 'view') return;
        const currentUser = participants.get(userId ?? 'unidentified');
        checkSessionLimit(currentUser, getTotalSessions());
    }, [
        checkSessionLimit,
        contentMode,
        participants,
        userId,
        getTotalSessions
    ]);
    return {};
};

});

parcelRegister("k9TfW", function(module, exports) {

$parcel$export(module.exports, "fetchPresenceAGGUsers", () => $aed2f5bf61ddaaa1$export$9db34321b84dd37a);
/** @graphql agg **/ 
var $d2LG0 = parcelRequire("d2LG0");

var $gKr8t = parcelRequire("gKr8t");
const $aed2f5bf61ddaaa1$export$9db34321b84dd37a = (accountIds)=>{
    return (0, $gKr8t.getAGGClient)().query({
        query: (0, $d2LG0.default)`query fetchPresenceAGGUsersQuery($accountIds:[ID!]!){users(accountIds:$accountIds){accountId name picture}}`,
        variables: {
            accountIds: accountIds
        }
    }).then(({ data: data })=>{
        return data?.users?.filter((user)=>user?.accountId).map((user)=>({
                avatar: user.picture ?? '',
                email: '',
                name: user.name ?? '',
                userId: user.accountId || ''
            })) ?? [];
    });
};

});

parcelRegister("9UaSY", function(module, exports) {

$parcel$export(module.exports, "fetchPresenceConfluenceUsers", () => $9cba87adb0d6c766$export$bf12d28b3016b36b);
/** @graphql cc **/ 
var $d2LG0 = parcelRequire("d2LG0");

var $hp2SH = parcelRequire("hp2SH");

var $l8FG6 = parcelRequire("l8FG6");
const $9cba87adb0d6c766$export$bf12d28b3016b36b = (accountIds)=>{
    return (0, $hp2SH.getApolloClient)().query({
        query: (0, $d2LG0.default)`query fetchPresenceConfluenceUsersQuery($accountIds:[String]){confluenceUsers(accountIds:$accountIds){nodes{profilePicture{isDefault path(type:RELATIVE)}...on KnownUser{accountId}...on UnknownUser{accountId}displayName permissionType}}}`,
        variables: {
            accountIds: accountIds
        }
    }).then(({ data: data })=>{
        return data?.confluenceUsers?.nodes?.filter((user)=>user?.accountId).map((user)=>({
                avatar: user?.profilePicture?.path ?? '',
                email: '',
                isGuest: (user?.permissionType === (0, $l8FG6.SitePermissionType).EXTERNAL) ?? undefined,
                name: user?.displayName ?? '',
                userId: user?.accountId ?? ''
            })) ?? [];
    });
};

});
parcelRegister("l8FG6", function(module, exports) {

$parcel$export(module.exports, "SitePermissionType", () => $9dbb8a2240011757$export$8995abb8169b2cb8);
/**
 * @generated SignedSource<<f3d335ae492aece071328bb1d0e330a1>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 *
 * @see https://go/typsy
 **/ var $9dbb8a2240011757$export$8995abb8169b2cb8 = /*#__PURE__*/ function(SitePermissionType) {
    SitePermissionType["ANONYMOUS"] = "ANONYMOUS";
    SitePermissionType["APP"] = "APP";
    SitePermissionType["EXTERNAL"] = "EXTERNAL";
    SitePermissionType["INTERNAL"] = "INTERNAL";
    SitePermissionType["JSD"] = "JSD";
    return SitePermissionType;
}({});

});




parcelRegister("lx2Vu", function(module, exports) {

$parcel$export(module.exports, "CanvasPresence", () => $09642762dd72a71c$export$4232d0c4c5b2a438);

var $gwFzn = parcelRequire("gwFzn");

var $bQm3c = parcelRequire("bQm3c");

var $jXpbL = parcelRequire("jXpbL");

var $6S5EB = parcelRequire("6S5EB");

var $lkApp = parcelRequire("lkApp");

var $aC5ZO = parcelRequire("aC5ZO");

var $fgzua = parcelRequire("fgzua");
// don't have activity for canvas, just default to viewer
const $09642762dd72a71c$var$ACTIVITY = 'viewer';
const $09642762dd72a71c$var$CONTENT_MODE = 'view';
const $09642762dd72a71c$export$4232d0c4c5b2a438 = ({ collaborators: collaborators, contentId: contentId, contentType: contentType, analyticSource: analyticSource })=>{
    const initialParticipants = (0, $lkApp.useParticipants)();
    const [{ presenceId: presenceId }] = (0, $jXpbL.useNativeCollabPresenceState)();
    const isExternal = (0, $6S5EB.isExternalShareRequest)();
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    // we never want to use the preloaded current user for whiteboards since we depend on the color, since it matches the sticky notes
    const shouldUsePreloadedCurrentUser = contentType === 'database' && !isExternal;
    const createOnClickHandler = (collaborator)=>{
        return collaborator.followCursor === true ? ()=>{
            collaborator.onClick?.();
        } : collaborator.onClick;
    };
    /**
	 * If we're not on an external route, get the current cached user; otherwise, wait for current user to come from canvas websocket
	 * Here's a more in-depth explanation
	 *
	 * isExternal = on a public link
	 * At this time external routes aren’t SSRd so we can’t preload. As a result, our user won't be cached
	 *
	 * The possible solutions are
	 * - Get external pages to be SSRd (which was too heavy of a lift at this time of implementation)
	 * - Add photos to the existing user call in SessionDataQuery or SiteInformationQuery
	 * - Just wait for collaborators to come in from websocket connection (which is the current implementation)
	 * right now, we have issues until we can preload users on external routes so don't worry about showing current user before socket connection establishes
	 * we could ad a preloader for external routes; however, external pages don't appeared to be SSRd.
	 *
	 * @param isExternal true if we're on an /external route, otherwise false
	 * @param collaborators list that comes from canvas websocket connection
	 * @returns current user from cache or canvas. Otherwise return undefined
	 */ const getCurrentUser = (0, $gwFzn.useCallback)((collaborators)=>{
        if (!shouldUsePreloadedCurrentUser && collaborators?.me) {
            const { me: me } = collaborators;
            //userId from canvas will already be unidentified if user is anonymous and can't be null
            return {
                activity: $09642762dd72a71c$var$ACTIVITY,
                color: me.color,
                followCursor: me.followCursor,
                id: me.userId,
                isCurrentUser: true,
                name: me.name,
                onClick: createOnClickHandler(me),
                src: me.avatar.src ?? '',
                userId: me.userId
            };
        } else if (shouldUsePreloadedCurrentUser) {
            const currentParticipantId = userId ?? presenceId;
            const currentParticipant = currentParticipantId ? initialParticipants.get(currentParticipantId) : undefined;
            // always want to use the currentParticipant instead of waiting for "me" from collaborators for better performance
            if (currentParticipant) return {
                activity: $09642762dd72a71c$var$ACTIVITY,
                id: currentParticipant.id,
                isCurrentUser: true,
                isGuest: currentParticipant.isGuest,
                name: currentParticipant.name,
                src: currentParticipant.src,
                userId: currentParticipant.userId
            };
        }
        return undefined;
    }, [
        initialParticipants,
        presenceId,
        shouldUsePreloadedCurrentUser,
        userId
    ]);
    const participants = (0, $gwFzn.useMemo)(()=>{
        const result = [];
        const currentUser = getCurrentUser(collaborators);
        if (currentUser) result.push(currentUser);
        collaborators?.collaborators?.forEach((collaborator)=>{
            const id = collaborator.userId;
            result.push({
                id: id,
                userId: id,
                name: collaborator.name,
                color: collaborator.color,
                src: collaborator.avatar.src ?? '',
                // we don't have activities on canvas, right now we need to default to viewer as downstream components depend on activity being present
                activity: $09642762dd72a71c$var$ACTIVITY,
                onClick: createOnClickHandler(collaborator),
                followCursor: collaborator.followCursor
            });
        });
        return result;
    }, [
        collaborators,
        getCurrentUser
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $fgzua.PresenceChangeboarding), {
        contentId: contentId,
        contentMode: $09642762dd72a71c$var$CONTENT_MODE,
        contentType: contentType,
        totalParticipants: participants.length
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $aC5ZO.PresenceAvatarGroup), {
        contentId: contentId,
        contentMode: $09642762dd72a71c$var$CONTENT_MODE,
        contentType: contentType,
        analyticSource: analyticSource,
        onLoadMoreClick: ()=>{},
        participants: participants,
        totalParticipants: participants.length
    }));
};

});



//# sourceMappingURL=ContentHeaderPresence.751e4421.js.map
